import React from 'react'
import { Plus } from 'lucide-react'
import CollapsibleSectionHeader from '../../../../OrderForm/components/CollapsibleSectionHeader'
import { ORDER_SECTION_IDS } from '../../../../OrderForm/constants'
import { useOrderItems } from '../../contexts/OrderItemsContext'
import {
  ActionOutlineButton, ActionSolidButton, Card, CenteredButtonsRow, ItemsListContainer,
} from '../../style'
import KitGroup from './KitGroup'
import ProductCard from './ProductCard'

const ItemsSection: React.FC = () => {
  const {
    addedProducts, kitCount, setKitCount, isItemsSectionOpen, setIsItemsSectionOpen,
    setProductToEdit, setEditingProductIndex, setOpenProductIndex, setShowAddProductForSection,
    closeProductEdit,
  } = useOrderItems()

  const standaloneProducts = addedProducts
    .map((p, i) => ({ product: p, index: i }))
    .filter(({ product }) => product.kitIndex === null || product.kitIndex === undefined)

  return (
    <Card id={ORDER_SECTION_IDS.items}>
      <CollapsibleSectionHeader
        title={<>Itens do pedido <span style={{ color: '#e53e3e', marginLeft: '4px' }}>*</span></>}
        isOpen={isItemsSectionOpen}
        onToggle={() => setIsItemsSectionOpen((v) => !v)}
      />

      {isItemsSectionOpen && (
        <>
          <ItemsListContainer>
            {standaloneProducts.map(({ product, index }) => (
              <ProductCard key={`${product.fashionProductId}-${index}`} product={product} index={index} />
            ))}

            {Array.from({ length: kitCount }, (_, kitIdx) => (
              <KitGroup key={`kit-section-${kitIdx}`} kitIdx={kitIdx} />
            ))}
          </ItemsListContainer>

          <CenteredButtonsRow>
            <ActionOutlineButton type="button" onClick={() => {
              setProductToEdit(null)
              setEditingProductIndex(null)
              setOpenProductIndex(null)
              setShowAddProductForSection('standalone')
            }}>
              <Plus size={16} /> Adicionar Novo Item
            </ActionOutlineButton>

            <ActionSolidButton type="button" onClick={() => {
              setKitCount((prev) => prev + 1)
              closeProductEdit()
            }}>
              <Plus size={16} /> Adicionar Conjunto
            </ActionSolidButton>
          </CenteredButtonsRow>
        </>
      )}
    </Card>
  )
}

export default ItemsSection
